import { Color } from "@repo/app-types/constants/colors";
import type { CustomFieldCondition } from "@repo/app-types/entities/filterConditions";
import { Size } from "@repo/ui/helpers/helpers";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { Pill } from "@repo/ui/Pills/pill";
import type { FC } from "react";

export interface BooleanCustomFieldConditionMenuProps {
  customFieldDefinitionId: string;
  onSelect: (condition: CustomFieldCondition) => void;
}

export const BooleanCustomFieldConditionMenu: FC<
  BooleanCustomFieldConditionMenuProps
> = (props) => {
  return (
    <SimpleMenu aria-label="Boolean value">
      <SimpleMenuItem
        onAction={() =>
          props.onSelect({
            customFieldDefinitionId: props.customFieldDefinitionId,
            operator: "=",
            value: true,
          })
        }
      >
        <Pill
          size={Size.SMALL}
          color={Color.Green}
          label={<span className="w-[2.5ch] text-center">Yes</span>}
        />
      </SimpleMenuItem>

      <SimpleMenuItem
        onAction={() =>
          props.onSelect({
            customFieldDefinitionId: props.customFieldDefinitionId,
            operator: "=",
            value: false,
          })
        }
      >
        <Pill
          size={Size.SMALL}
          color={Color.Red}
          label={<span className="w-[2.5ch] text-center">No</span>}
        />
      </SimpleMenuItem>
    </SimpleMenu>
  );
};
